const config = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    clientUrl: process.env.REACT_APP_CLIENT_URL,
    testMode: process.env.REACT_APP_TEST_MODE === 'true',
} 

export default config;